import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core'
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router'
import { SETTINGS, SPANISH_ERROR_MESSAGES, VALIDATION_ERROR_MESSAGES } from 'superlikers-dynamic-forms'
import { API_BASE_URL, headersInterceptor } from 'superlikers-microsites-api'
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'

import { routes } from './app.routes'

import { environment } from '../environments/environment'
import { settings } from '@shared/utils/forms-settings'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withFetch(), withInterceptors([headersInterceptor])),
    {
      provide: API_BASE_URL,
      useValue: environment.baseUrl
    },
    {
      provide: VALIDATION_ERROR_MESSAGES,
      useFactory: () => SPANISH_ERROR_MESSAGES
    },
    {
      provide: SETTINGS,
      useValue: settings
    }
  ]
}
